import React from "react";
import { CheckCircle2, Clock, PauseCircle } from "lucide-react";
import { AVAILABILITY } from "@/lib/api";

const ICONS = { check: CheckCircle2, clock: Clock, pause: PauseCircle };

export default function AvailabilityPill({ status, size = "sm" }) {
  const conf = AVAILABILITY[status] || AVAILABILITY.not_accepting;
  const Icon = ICONS[conf.icon];
  const pad = size === "lg" ? "px-3 py-1.5 text-sm" : "px-2.5 py-1 text-xs";
  return (
    <span
      data-testid={`availability-pill-${status}`}
      className={`inline-flex items-center gap-1.5 rounded-full font-semibold ${pad}`}
      style={{ backgroundColor: conf.soft, color: conf.color, border: `1px solid ${conf.color}33` }}
    >
      <Icon className="w-3.5 h-3.5" aria-hidden="true" />
      {conf.label}
    </span>
  );
}

export function PresencePill({ presence }) {
  if (presence === "online") {
    return (
      <span className="inline-flex items-center gap-1.5 text-xs font-semibold text-[#1F7A4D]">
        <span className="w-2 h-2 rounded-full bg-[#1F7A4D]" /> Online now
      </span>
    );
  }
  if (presence === "recently_active") {
    return (
      <span className="inline-flex items-center gap-1.5 text-xs font-medium text-[#4B5A60]">
        <span className="w-2 h-2 rounded-full bg-[#B7791F]" /> Recently active
      </span>
    );
  }
  return (
    <span className="inline-flex items-center gap-1.5 text-xs font-medium text-[#7A868B]">
      <span className="w-2 h-2 rounded-full bg-[#C4CBCD]" /> Offline
    </span>
  );
}
